import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface FacetsWrapperProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    onScroll: (e: React.UIEvent<HTMLDivElement>) => void
    dataTestId: string
    children: JSX.Element
}

const FacetsWrapper = memo(({templating, onScroll, dataTestId, children}: FacetsWrapperProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <ComponentName onScroll={onScroll} data-testid={dataTestId}>
                {children}
            </ComponentName>
        </Suspense>
    )
})

FacetsWrapper.displayName = "FacetsWrapper"

export default connect(FacetsWrapper)
